<template>
  <div class="simpletable-editor">
    <div class="row" style="position: relative">
      <v-col cols="12">
        <v-simple-table style="border: 2px solid #bcbcbc; border-radius: 5px;">
          <template v-slot:default>
            <thead>
              <tr style="background-color: #f0f0f0;
                  color: #222;
                  text-align: center;
                  font-size: 13px;
                  font-weight: 400;
                  white-space: nowrap;
                  height: 26px;
                  line-height: 25px;">
                <th v-for="(h, index) in table.headers" :key="'header-' + index" class="text-left">
                  <v-text-field
                    :label="h.label ? '' : db.alphabet[index + 1]"
                    v-model="h.label"
                    dense
                    class="text-field-transparent"
                    solo
                    flat
                    hide-details
                    style="border: 0">
                  </v-text-field>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in table.rows" :key="'row-' + index">
                <td
                  v-for="(field, i) in row"
                  :key="'field-'+i+index"
                  :class="cellClasses(index, i)"
                  :style="cellStyle(index, i)">
                  <v-text-field
                    :ref="`input-${index}-${i}`"
                    :data-row="index"
                    :data-col="i"

                    label=""
                    v-model="row[i]"
                    :style="cellInputStyle(index, i)"
                    :readonly="isCellReadOnly(index, i)"
                    :disabled="isCellReadOnly(index, i)"
                    :tabindex="isCellReadOnly(index, i) ? -1 : 0"
                    dense
                    solo
                    flat
                    hide-details
                    class="text-field-transparent"
                    placeholder="..."
                    @keydown="moveInput">
                  </v-text-field>

                  <v-menu v-if="ui.mode == 'full'" transition="slide-y-transition" bottom :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="btn-actions cell-config-actions" v-bind="attrs" v-on="on">
                        <v-icon small>mdi-tune</v-icon>
                      </div>
                    </template>
                    <v-list class="pb-0" @click.stop>
                      <v-list-item @click.stop="toggleCellConfig(index, i, 'bold', true)">
                        <v-list-item-subtitle>{{ $t('bloquesEditTableblockeditor.bold') }}</v-list-item-subtitle>
                        <v-list-item-icon>
                          <v-icon v-if="getCellConfig(index, i).bold" small>mdi-check</v-icon>
                        </v-list-item-icon>
                      </v-list-item>

                      <v-list-item @click.stop="toggleCellConfig(index, i, 'disabled', true)">
                        <v-list-item-subtitle>{{ $t('bloquesEditTableblockeditor.readOnly') }}</v-list-item-subtitle>
                        <v-list-item-icon>
                          <v-icon v-if="getCellConfig(index, i).disabled" small>mdi-check</v-icon>
                        </v-list-item-icon>
                      </v-list-item>

                      <v-divider></v-divider>

                      <v-list-item>
                        <div class="row">
                          <div class="col" style="color: rgba(0, 0, 0, 0.6); font-size: 14px">
                            {{ $t('bloquesEditTableblockeditor.border') }}
                          </div>
                          <div
                            class="col text-center"
                            style="color: rgba(0, 0, 0, 0.6); font-size: 14px; cursor: pointer"
                            @click.stop="setCellConfig(index, i, 'border', '1px solid #222')">
                            {{ $t('bloquesEditTableblockeditor.solid') }}
                          </div>
                          <div
                            class="col text-center"
                            style="color: rgba(0, 0, 0, 0.6); font-size: 14px; cursor: pointer"
                            @click.stop="setCellConfig(index, i, 'border', '1px dashed #222')">
                            {{ $t('bloquesEditTableblockeditor.dashed') }}
                          </div>
                          <div
                            class="col text-center"
                            style="color: rgba(0, 0, 0, 0.6); font-size: 14px; cursor: pointer"
                            @click.stop="removeCellConfig(index, i, 'border')">
                            {{ $t('bloquesEditTableblockeditor.none') }}
                          </div>
                        </div>
                      </v-list-item>

                      <v-divider></v-divider>

                      <v-list-item @click.stop="clearCellConfig(index, i)">
                        <v-list-item-subtitle>{{ $t('bloquesEditTableblockeditor.clearCellConfig') }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                    <v-card flat class="cell-color-config" @click.stop>
                      <v-card-text class="py-2">
                        <div class="cell-color-section">
                          <div class="cell-color-title">{{ $t('bloquesEditTableblockeditor.background') }}</div>
                          <v-color-picker
                            :value="getPickerColor(index, i, 'background')"
                            mode="hex"
                            hide-inputs
                            hide-mode-switch
                            dot-size="18"
                            swatches-max-height="120"
                            @input="setCellConfig(index, i, 'background', normalizeColor($event))">
                          </v-color-picker>
                          <div class="cell-color-value-row">
                            <v-text-field
                              dense
                              outlined
                              hide-details
                              type="number"
                              min="0"
                              max="100"
                              suffix="%"
                              class="cell-opacity-input"
                              :label="$t('bloquesEditTableblockeditor.opacity')"
                              :value="getCellOpacity(index, i, 'background')"
                              @input="setCellOpacity(index, i, 'background', $event)">
                            </v-text-field>
                            <div class="cell-color-preview" :style="colorPreviewStyle(index, i, 'background')"></div>
                            <v-text-field
                              dense
                              outlined
                              hide-details
                              class="cell-color-code-input"
                              :value="getCellColor(index, i, 'background')"
                              @change="setCellColorInput(index, i, 'background', $event)">
                              <template v-slot:append>
                                <v-btn icon x-small class="cell-color-action" @click.stop="copyColor(getCellColor(index, i, 'background'))">
                                  <v-icon small>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon x-small class="cell-color-action" @click.stop="clearCellColor(index, i, 'background')">
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div class="cell-color-section">
                          <div class="cell-color-title">{{ $t('bloquesEditTableblockeditor.textColor') }}</div>
                          <v-color-picker
                            :value="getPickerColor(index, i, 'textColor')"
                            mode="hex"
                            hide-inputs
                            hide-mode-switch
                            dot-size="18"
                            swatches-max-height="120"
                            @input="setCellConfig(index, i, 'textColor', normalizeColor($event))">
                          </v-color-picker>
                          <div class="cell-color-value-row">
                            <v-text-field
                              dense
                              outlined
                              hide-details
                              type="number"
                              min="0"
                              max="100"
                              suffix="%"
                              class="cell-opacity-input"
                              :label="$t('bloquesEditTableblockeditor.opacity')"
                              :value="getCellOpacity(index, i, 'textColor')"
                              @input="setCellOpacity(index, i, 'textColor', $event)">
                            </v-text-field>
                            <div class="cell-color-preview" :style="colorPreviewStyle(index, i, 'textColor')"></div>
                            <v-text-field
                              dense
                              outlined
                              hide-details
                              class="cell-color-code-input"
                              :value="getCellColor(index, i, 'textColor')"
                              @change="setCellColorInput(index, i, 'textColor', $event)">
                              <template v-slot:append>
                                <v-btn icon x-small class="cell-color-action" @click.stop="copyColor(getCellColor(index, i, 'textColor'))">
                                  <v-icon small>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon x-small class="cell-color-action" @click.stop="clearCellColor(index, i, 'textColor')">
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td colspan="99" style="padding: 5px;
                  text-align: center;
                  cursor: pointer;
                  background-color: rgb(236, 245, 240);
                  text-transform: uppercase;
                  font-weight: bold;
                  font-size: 9px;
                  color: rgb(113, 113, 113);
                  user-select: none;
                  border: 1px dashed rgb(204, 204, 204) !important;"
                  @click="addRowAtIndex('bottom')">
                  {{$t('tableBlockEditor.addRow')}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <div
        v-if="ui.mode == 'full'"
        @click="doAction('add-right', table.headers.length)"
        style="position: absolute;right: 0;top: calc((100% - 90%) / 2);
          cursor: pointer;width: 10px;height: 90%;
          background: rgb(240 240 240);border-radius: 6px;">
        <div style="height: 100%;
          background: rgb(188 188 188);
          width: 3px;
          margin: auto;">
            <i data-v-603eefba="" aria-hidden="true" class="v-icon notranslate icon-menu mdi mdi-plus theme--light" style="margin: auto;top: 45%;right: 8px;/* display: none; */z-index: 666;background: #93ce95f7;border-radius: 50%;color: #4caf50 !important;font-size: 20px; padding: 1px;"></i>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @project: certiapp-nuxt
 * @file:    \pages\bloques\edit\simpletableBlockEditor.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 9th May 2022
 * Last Modified: Mon Jun 06 2022
 **/

import { uuid } from 'vue-uuid'

import notifications from '~/util/notificationHelper'

export default {
  props: ['_ui', '_table'],

  data: () => ({
    table: {
      rows: [
        ['', ''],
        ['', ''],
        ['', ''],
      ],
      headers: [{ label: '' }, { label: '' }],
      footers: [{ formula: 'count' }, { formula: 'sum' }],
      cellConfig: {},
    },

    db: {
      alphabet: [],

      actions: {
        column: {
          'add-right': {
            label: 'Insertar a la derecha',
          },
          'add-left': {
            label: 'Insertar a la izquierda',
          },
          'remove-col': {
            label: 'Eliminar columna',
          },
        },

        row: {
          'add-top': {
            label: 'Insertar 1 encima',
          },
          'add-bottom': {
            label: 'Insertar 1 debajo',
          },
          'remove-row': {
            label: 'Eliminar fila',
          },
        },

        colors: [
          '#f0f0f0',
          'antiquewhite',
          'aquamarine',
          'cornflowerblue',
          '#c32c2c',
          '#2cc365',
          '#c3b42c',
        ],
      },

      defaults: {
        row: [],
        header: { label: '' },
        footer: { formula: 'count' },
      },
    },

    ui: {
      mode: 'full',
      loading: false,
      isValid: false,
    },
  }),

  computed: {},

  methods: {
    cellKey(row, col) {
      return row + ':' + col
    },

    getCellConfig(row, col) {
      return this.table.cellConfig?.[this.cellKey(row, col)] || {}
    },

    hasCellConfig(row, col) {
      return Object.keys(this.getCellConfig(row, col)).length > 0
    },

    cellClasses(row, col) {
      let config = this.getCellConfig(row, col)

      return {
        'is-bold': Boolean(config.bold),
        'is-readonly': Boolean(config.disabled),
        'has-cell-config': this.hasCellConfig(row, col),
      }
    },

    cellStyle(row, col) {
      let config = this.getCellConfig(row, col)
      let style = {}

      if (config.background) style.backgroundColor = this.colorWithOpacity(config.background, config.backgroundOpacity)
      if (config.textColor) style.color = this.colorWithOpacity(config.textColor, config.textColorOpacity)
      if (config.border) style.border = config.border

      return style
    },

    cellInputStyle(row, col) {
      let config = this.getCellConfig(row, col)
      let style = { border: '0' }

      if (config.textColor) style.color = this.colorWithOpacity(config.textColor, config.textColorOpacity)

      return style
    },

    isCellReadOnly(row, col) {
      return Boolean(this.getCellConfig(row, col).disabled)
    },

    normalizeColor(color) {
      if (!color) return ''
      let normalized = ''
      if (typeof color === 'string') normalized = color
      if (color.hexa) normalized = color.hexa
      if (color.hex) normalized = color.hex
      if (normalized.length === 9) normalized = normalized.substring(0, 7)
      return normalized
    },

    opacityKey(key) {
      return key + 'Opacity'
    },

    getPickerColor(row, col, key) {
      return this.getCellColor(row, col, key) || '#000000'
    },

    colorPreviewStyle(row, col, key) {
      return {
        background: this.colorWithOpacity(
          this.getCellColor(row, col, key) || '#000000',
          this.getCellOpacity(row, col, key)
        ),
      }
    },

    getCellOpacity(row, col, key) {
      let opacity = this.getCellConfig(row, col)[this.opacityKey(key)]
      return opacity === undefined ? 100 : opacity
    },

    setCellOpacity(row, col, key, value) {
      let opacity = parseInt(value, 10)
      if (Number.isNaN(opacity)) opacity = 100
      opacity = Math.min(100, Math.max(0, opacity))
      this.setCellConfig(row, col, this.opacityKey(key), opacity)
    },

    clearCellColor(row, col, key) {
      this.removeCellConfig(row, col, key)
      this.removeCellConfig(row, col, this.opacityKey(key))
    },

    setCellColorInput(row, col, key, value) {
      let color = (value || '').trim()
      if (!color) {
        this.clearCellColor(row, col, key)
        return
      }

      if (!color.startsWith('#')) color = '#' + color
      if (/^#[0-9A-Fa-f]{6}$/.test(color)) {
        this.setCellConfig(row, col, key, color.toUpperCase())
      }
    },

    colorWithOpacity(color, opacity = 100) {
      if (!color) return ''
      if (!color.startsWith('#')) return color
      let hex = color.replace('#', '')
      if (hex.length === 8) hex = hex.substring(0, 6)
      if (hex.length !== 6) return color

      let alpha = Math.min(100, Math.max(0, parseInt(opacity, 10))) / 100
      let red = parseInt(hex.substring(0, 2), 16)
      let green = parseInt(hex.substring(2, 4), 16)
      let blue = parseInt(hex.substring(4, 6), 16)
      return `rgba(${red}, ${green}, ${blue}, ${alpha})`
    },

    getCellColor(row, col, key) {
      let color = this.getCellConfig(row, col)[key] || ''
      if (color.length === 9) color = color.substring(0, 7)
      return color
    },

    async copyColor(color) {
      if (!color) return

      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(color)
        } else {
          let input = document.createElement('input')
          input.value = color
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }

        this.$store.commit('notification/show', {
          text: this.$t('bloquesEditTableblockeditor.colorCopied'),
          color: 'success',
          timeout: 1500,
        })
      } catch (e) {
        this.$store.commit('notification/show', {
          text: this.$t('bloquesEditTableblockeditor.colorCopyError'),
          color: 'warning',
          timeout: 1500,
        })
      }
    },

    setCellConfig(row, col, key, value) {
      if (!this.table.cellConfig || Array.isArray(this.table.cellConfig)) {
        this.$set(this.table, 'cellConfig', { ...this.table.cellConfig })
      }

      let cellKey = this.cellKey(row, col)
      let config = { ...this.getCellConfig(row, col), [key]: value }
      this.$set(this.table.cellConfig, cellKey, config)
      this.$forceUpdate()
    },

    removeCellConfig(row, col, key) {
      if (!this.table.cellConfig || Array.isArray(this.table.cellConfig)) {
        this.$set(this.table, 'cellConfig', { ...this.table.cellConfig })
      }

      let cellKey = this.cellKey(row, col)
      let config = { ...this.getCellConfig(row, col) }
      this.$delete(config, key)

      if (Object.keys(config).length) {
        this.$set(this.table.cellConfig, cellKey, config)
      } else {
        this.$delete(this.table.cellConfig, cellKey)
      }

      this.$forceUpdate()
    },

    toggleCellConfig(row, col, key, value) {
      let config = this.getCellConfig(row, col)
      if (config[key] === value) {
        this.removeCellConfig(row, col, key)
      } else {
        this.setCellConfig(row, col, key, value)
      }
    },

    clearCellConfig(row, col) {
      if (!this.table.cellConfig) return
      this.$delete(this.table.cellConfig, this.cellKey(row, col))
      this.$forceUpdate()
    },

    //+-------------------------------------------------
    // moveInput()
    // Detects arrow keys and moves focus to the next
    // -----
    // Created on Fri May 20 2022
    //+-------------------------------------------------
    moveInput(event) {
      let arrows = [37, 38, 39, 40]
      if (arrows.indexOf(event.keyCode) == -1) return

      let component = null
      let row = parseInt(event.target.dataset.row)
      let col = parseInt(event.target.dataset.col)

      if (event.keyCode == 37) col--
      if (event.keyCode == 38) row--
      if (event.keyCode == 39) col++
      if (event.keyCode == 40) row++

      // console.warn(row, col, 'input-' + (row - 1) + '-' + col, component)

      component = this.$refs['input-' + row + '-' + col]
      if (component && component.length) {
        component = component[0]
        component.$el.querySelector('input').focus()
        component.$el.querySelector('input').select()
      }

      event.preventDefault()
    },

    //+-------------------------------------------------
    // doAction()
    // Performs an action defined by Key
    // -----
    // Created on Mon Jun 28 2021
    //+-------------------------------------------------
    doAction(action, index, secondary) {
      if (action == 'add-right' || action == 'add-left') {
        let position = action == 'add-right' ? index + 1 : index
        this.addColumnAtIndex(position)
      }

      if (action == 'add-top' || action == 'add-bottom') {
        let position = action == 'add-top' ? index : index + 1
        this.addRowAtIndex(position)
      }

      if (action == 'remove-row') {
        this.removeRow(index)
      }

      if (action == 'remove-col') {
        this.removeCol(index)
      }

      console.warn('🛠', 'Action performed: ', action)
    },

    //+-------------------------------------------------
    // addColumnAtIndex()
    // Adds a column to headers and each row
    // -----
    // Created on Mon Jun 28 2021
    //+-------------------------------------------------
    addColumnAtIndex(index) {
      let header = { ...this.db.defaults.header }
      let footer = { ...this.db.defaults.footer }

      this.table.headers.splice(index, 0, header)
      this.table.footers.splice(index, 0, footer)

      this.table.rows.forEach((row) => {
        row.splice(index, 0, '')
      })
      this.shiftCellConfigForColumn(index, 1)
    },

    //+-------------------------------------------------
    // addRowAtIndex()
    // Adds a new row
    // -----
    // Created on Tue Jun 29 2021
    //+-------------------------------------------------
    addRowAtIndex(index) {
      index = index == 'bottom' ? this.table.rows.length : index

      let newRow = []
      this.table.headers.forEach((item) => {
        newRow.push('')
      })

      this.table.rows.splice(index, 0, newRow)
      this.shiftCellConfigForRow(index, 1)
    },

    removeRow(index, type) {
      this.table.rows.splice(index, 1)
      this.shiftCellConfigForRow(index, -1)
    },

    removeCol(index, type) {
      this.table.rows.forEach((row) => {
        row.splice(index, 1)
      })
      this.table.footers.splice(index, 1)
      this.table.headers.splice(index, 1)
      this.shiftCellConfigForColumn(index, -1)
    },

    shiftCellConfigForRow(index, offset) {
      if (!this.table.cellConfig) return

      let shifted = {}
      Object.keys(this.table.cellConfig).forEach((key) => {
        let [row, col] = key.split(':').map(Number)
        if (offset > 0 && row >= index) row += offset
        if (offset < 0) {
          if (row === index) return
          if (row > index) row += offset
        }
        shifted[this.cellKey(row, col)] = this.table.cellConfig[key]
      })

      this.$set(this.table, 'cellConfig', shifted)
    },

    shiftCellConfigForColumn(index, offset) {
      if (!this.table.cellConfig) return

      let shifted = {}
      Object.keys(this.table.cellConfig).forEach((key) => {
        let [row, col] = key.split(':').map(Number)
        if (offset > 0 && col >= index) col += offset
        if (offset < 0) {
          if (col === index) return
          if (col > index) col += offset
        }
        shifted[this.cellKey(row, col)] = this.table.cellConfig[key]
      })

      this.$set(this.table, 'cellConfig', shifted)
    },

    //+-------------------------------------------------
    // getDataFromProps()
    // Assigns this.table values from _data
    // -----
    // Created on Tue Jul 06 2021
    //+-------------------------------------------------
    getDataFromProps() {
      if (this._table && this._table.rows) {
        this.table = { ...this._table }
      }
      if (!this.table.cellConfig || Array.isArray(this.table.cellConfig)) {
        this.$set(this.table, 'cellConfig', { ...this.table.cellConfig })
      }

      this.ui.mode = this._ui?.mode || 'limited'
    },

    //+-------------------------------------------------
    // normalizeColsAndRows()
    // Ensures that there is enough elements in each row
    // for every header
    // -----
    // Created on Wed Jun 30 2021
    //+-------------------------------------------------
    normalizeColsAndRows() {
      let headers = this.table.headers.length
      this.table.rows.forEach((row) => {
        if (row.length < headers) {
          for (let i = row.length; i < headers; i++) {
            row.push('')
          }
        }
      })
    },

    createKeyedAlphabet() {
      var a = 97
      var charArray = {}
      for (var i = 0; i < 26; i++) charArray[i + 1] = String.fromCharCode(a + i).toUpperCase()

      this.db.alphabet = charArray
    },

    //+-------------------------------------------------
    // Funciones de flujo
    // Submit, validate, Upload...
    //+-------------------------------------------------

    //+-------------------------------------------------
    // Async API crud actions
    //+-------------------------------------------------

    //+-------------------------------------------------
    // Async API requests
    //+-------------------------------------------------

    async init() {
      this.getDataFromProps()
      this.createKeyedAlphabet()
      this.normalizeColsAndRows()
    },
  },

  mounted() {
    this.init()
  },
}
</script>

<style>
.simpletable-editor td {
  position: relative;
}

.simpletable-editor td .v-input input {
  color: inherit;
}

.simpletable-editor td.is-bold,
.simpletable-editor td.is-bold input {
  font-weight: 700;
}

.simpletable-editor td.is-readonly .v-input,
.simpletable-editor td.is-readonly .v-input input {
  pointer-events: none;
}

.simpletable-editor td.is-readonly .v-input--is-disabled {
  opacity: 1;
}

.simpletable-editor td.is-readonly .v-input--is-disabled input {
  color: inherit;
}

.simpletable-editor td.has-cell-config {
  outline: 1px dashed rgba(76, 175, 80, 0.45);
  outline-offset: -2px;
}

.simpletable-editor .btn-actions {
  opacity: 0;
  outline: 1px dashed #d8d8d8;
  outline-offset: -1px;
  position: absolute;
  right: 4px;
  top: 5px;
  line-height: 14px;
  padding: 0px;
  transition: opacity 0.3s;
}

.simpletable-editor td:hover .btn-actions {
  opacity: 1;
}

.simpletable-editor .cell-config-actions {
  right: 4px;
}

.v-menu__content .cell-color-config {
  position: relative;
  width: 320px;
}

.v-menu__content .cell-color-title {
  color: rgba(0, 0, 0, 0.7);
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.v-menu__content .cell-color-config .v-color-picker {
  width: 100%;
  box-shadow: none;
}

.v-menu__content .cell-color-section {
  position: relative;
}

.v-menu__content .cell-color-preview {
  flex: 0 0 42px;
  height: 28px;
  width: 42px;
}

.v-menu__content .cell-color-value-row {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.v-menu__content .cell-color-code-input {
  flex: 0 0 140px;
  max-width: 140px;
}

.v-menu__content .cell-color-action {
  color: #6b7280;
  height: 20px;
  margin-left: 2px;
  width: 20px;
}

.v-menu__content .cell-color-action:hover {
  color: #111827;
}

.v-menu__content .cell-color-action .v-icon {
  cursor: pointer;
  font-size: 16px;
}

.v-menu__content .cell-opacity-input {
  flex: 0 0 82px;
  max-width: 82px;
}

.v-menu__content .cell-opacity-input input {
  text-align: center;
}

.v-menu__content .cell-color-config .v-color-picker__dot {
  display: none;
}

.v-menu__content .cell-color-config .v-color-picker__sliders {
  padding-right: 0;
}

.v-menu__content .cell-color-config .v-slider__thumb::before,
.v-menu__content .cell-color-config .v-slider__thumb-container--focused .v-slider__thumb::before {
  display: none !important;
  opacity: 0 !important;
}

.v-menu__content .cell-color-config .v-ripple__container,
.v-menu__content .cell-color-config .v-ripple__animation {
  display: none !important;
  opacity: 0 !important;
}

.simpletable-editor .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: transparent;
}
</style>
